import { useCallback } from "react";
import { GridFilterAction } from "../../../../system/hooks/useGridFilter";

interface ISearchParams {
    searchStore: string;
    searchOption: string;
}

interface IuseSearchDocumentProps {
    gridFilter: IGridFilter;
    dispatchGridFilter: React.Dispatch<GridFilterAction>;
}
export const useSearchDocument = ({ gridFilter, dispatchGridFilter }: IuseSearchDocumentProps) => {
    
    const getSearchValue = useCallback(({ searchOption, searchStore }: ISearchParams) => {
        dispatchGridFilter({
            type: 'paramSimpleFilter',
            payload: { gridParamFilter: { [searchOption]: searchStore }, gridColumnFilter: gridFilter.columnFilters },
        });
    }, [gridFilter]);

    return { getSearchValue };
};
